import { useState } from 'react';
import Skeleton from '@mui/material/Skeleton';

import EmployMePreview from '../../../employme-preview.png';
import SpotSpacePreview from '../../../spotspace-preview.png';
import ScrollrPreview from '../../../scollr-preview.png';
import SnafuWorldPreview from '../../../SnafuWorldPreview.png';

import './ProjectInfo.css';

const ProjectInfo = ({ id, loaded }) => {
    const projectData = [
        {
            name: 'AmeriaX',
            img: SnafuWorldPreview,
            link: 'https://ameriax.org',
            description: 'AmeriaX is a 2D MMORPG created with C++. Graphics are isometric creating a 3D-like visual experience. Over 200 accounts have been created in Alpha.',
            features: [
                'Please ask me about features of this game!',
            ],
            tech: [
                {name: 'C++', link: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/cplusplus/cplusplus-original.svg'}, // C++
                {name: 'LUA', link: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/lua/lua-original.svg'},
                {name: 'PHP', link: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/php/php-original.svg'},
                {name: 'JavaScript', link: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg'},
                {name: 'OpenGL', link: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/opengl/opengl-original.svg'},
                {name: 'MySQL', link: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original-wordmark.svg'}
            ]
        },
        {
            name: 'EmployMe',
            img: EmployMePreview,
            link: 'https://employme.onrender.com',
            description: 'EmployMe is a clone of LinkedIn. The goal of this site is to gain the experience of creating most features LinkedIn offers. This was one of many solo projects I worked on during my time at App Academy. The project is still in development.',
            features: [
                'Sign up',
                'log in',
                'log out',
                'Create Profile',
                'Update Profile',
                'Connect with Users',
                'Create Posts',
                'Update Posts',
                'Delete Posts',
                'Like Posts',
                'Comment on Posts',
                'Upload images',
                'Edit images',
                'Profile Pictures',
                'Profile Headers',
                'User Authentication',
                'Hashed Passwords',
                'Scrollable Feed',
                'NewsAPI',
                'AWS S3'
            ],
            tech: [
                {name: 'JavaScript', link: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg'}, // JavaScript
                {name: 'Python', link: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg'}, // Python
                {name: 'React', link: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg'}, // React
                {name: 'Redux', link: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/redux/redux-original.svg'}, // Redux
                {name: 'Flask', link: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flask/flask-original.svg'}, // Flask
                {name: 'SQLAlchemy', link: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/sqlalchemy/sqlalchemy-original.svg'}, // SQLAlchemy
                {name: 'SQLite', link: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/sqlite/sqlite-original.svg'}, // SQLite
                {name: 'PostgreSQL', link: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg'} // PostgreSQL
            ]
        },
        {
            name: 'SpotSpace',
            img: SpotSpacePreview,
            link: 'https://spotspace.onrender.com',
            description: 'SpotSpace is a clone of AirBnB. AirBnB has unique features and great search functionality. The goal for this site is to learn how to make similar functionality. The project is still in development.',
            features: [
                'Sign up',
                'log in',
                'log out',
                'Profile Pictures',
                'Create Spots',
                'Update Spots',
                'Delete Spots',
                'Spot Star Ratings',
                'Review Spots',
                'Edit Reviews',
                'Delete Reviews',
                'Upload images',
                'Edit images',
                'User Authentication',
                'Hashed Passwords',
                'Scrollable Feed',
                'AWS S3'
            ],
            tech: [
                {name: 'JavaScript', link: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg'}, // JavaScript
                {name: 'React', link: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg'}, // React
                {name: 'Redux', link: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/redux/redux-original.svg'}, // Redux
                {name: 'Express', link: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg'}, // Express
                {name: 'Sequelize', link: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/sequelize/sequelize-original.svg'}, // Sequelize
                {name: 'SQLite', link: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/sqlite/sqlite-original.svg'}, // SQLite
                {name: 'PostgreSQL', link: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg'} // PostgreSQL
            ]
        },
        {
            name: 'Scrollr',
            img: ScrollrPreview,
            link: 'https://scrollr.onrender.com',
            description: 'Scollr is a clone of Tumblr. This was a group project during my time at App Academy. This project was created in one week from scratch. I am currently working on a project to replace this for my portfolio.',
            features: [
                'Sign up',
                'log in',
                'log out',
                'Create Profile',
                'Update Profile',
                'Follow Users',
                'Create Posts',
                'Update Posts',
                'Delete Posts',
                'Like Posts',
                'Comment on Posts',
                'Upload images',
                'Edit images',
                'User Authentication',
                'Hashed Passwords',
                'Scrollable Feed',
                'AWS S3'
            ],
            tech: [
                {name: 'JavaScript', link: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg'}, // JavaScript
                {name: 'Python', link: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg'}, // Python
                {name: 'React', link: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg'}, // React
                {name: 'Redux', link: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/redux/redux-original.svg'}, // Redux
                {name: 'Flask', link: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flask/flask-original.svg'}, // Flask
                {name: 'SQLAlchemy', link: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/sqlalchemy/sqlalchemy-original.svg'}, // SQLAlchemy
                {name: 'SQLite', link: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/sqlite/sqlite-original.svg'}, // SQLite
                {name: 'PostgreSQL', link: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg'} // PostgreSQL
            ]
        }
    ];
    
    const project = projectData[id];
    
    const [infoOption, setInfoOption] = useState('description');
    
    
    return (
        <div className='project-info-container'>
            <article className='project-container'>
                <a href={`${project.link}`} className='project-img-navlink' title={`Click to view ${project.name}`} target='_blank' rel="noreferrer">
                    
                    <div className='project-image-overlay'>
                        <span className='project-number'>0{id + 1}</span>
                        {loaded ?
                        <div className='project-title-live'>
                            <div className='pulse-effect'></div>
                            <p className='project-img-title'>{project.name} is Live!</p>
                        </div>
                    :
                    <div className='project-title-live'>
                        <div className='pulse-effect2'></div>
                        <p className='project-img-title'>{project.name} is Loading!</p>
                    </div>
                    }
                    </div>
                    
                    {loaded ? <img src={project.img} alt={project.name}/>
                    // : <Skeleton variant="rectangular" sx={{opacity: 1.0}} animation="wave" width='100%' height='100%' />
                    : <Skeleton
                        variant="rectangular"
                        animation="wave"
                        width="100%"
                        height={320}
                        sx={{
                            bgcolor: 'rgba(173, 173, 173, 0.5)',
                            border: '2px solid rgb(24, 24, 24)',
                            borderRadius: '10px',
                        }}
                        />
                    }
                </a>
            
                <div className='project-info-div'>
                    <div className='project-info-select'>
                        <button className={`project-info-button-left ${infoOption === 'description' ? 'is-active' : ''}`}
                            onClick={() => setInfoOption('description')}
                            onMouseEnter={() => setInfoOption('description')}
                        >Overview</button>
                        <button
                            className={infoOption === 'features' ? 'is-active' : ''}
                            onClick={() => setInfoOption('features')}
                            onMouseEnter={() => setInfoOption('features')}
                        >Features</button>
                        <button className={`project-info-button-right ${infoOption === 'technologies' ? 'is-active' : ''}`}
                            onClick={() => setInfoOption('technologies')}
                            onMouseEnter={() => setInfoOption('technologies')}
                        >Tech</button>
                    </div>
                    
                    {infoOption === 'description' && 
                        <div className='project-info-content-container'>
                            <p className='project-description'>{project.description}</p>
                        </div>
                    }
                    
                    {infoOption === 'features' && 
                        <div className='project-info-content-container'>
                            <ul className='project-info-features-container'>
                                {project.features.map((feature, i) => 
                                    <li key={i}>{feature}</li>
                                )}
                            </ul>
                        </div>
                    }
                    
                    {infoOption === 'technologies' && 
                        <div className='project-info-content-container'>
                            <div className='project-info-tech-container'>
                                {project.tech.map((tech, i) => 
                                    <div className='project-info-tech-div' key={i}>
                                        <img title={tech.name} src={tech.link} alt={tech.name}/>
                                        <span>{tech.name}</span>
                                    </div>
                                )}
                            </div>
                        </div>
                    }
                </div>
            </article>
        </div>
    );
};


export default ProjectInfo;
